import React from "react";
import { Skeleton } from "@mui/material";

export const HeaderSkeleton: React.FC = () => {
  return (
    <>
      <div className="flex h-16 w-full flex-none items-center gap-2 px-4 sm:px-6 md:pl-12 md:pr-6 py-4">
        <Skeleton variant="circular" width={20} height={20} />
        <Skeleton variant="text" width={60} height={20} />
      </div>
      <div className="flex w-full flex-col items-center gap-4 px-4 sm:px-6 md:pl-12">
        <div className="flex w-full flex-col items-start gap-4">
          <Skeleton variant="text" width={300} height={32} />
          <Skeleton variant="text" width={400} height={20} />
        </div>
      </div>
    </>
  );
}; 